<template>
	<div v-bind:class="sidebarClasses" v-bind:data-background-color="backgroundColor" v-bind:data-active-color="activeColor">
		<div class="logo">
			<a class="simple-text logo-mini"><div class="logo-img"><img v-bind:src="logo" alt=""></div></a>
			<a class="simple-text logo-normal">{{ title }}</a>
		</div>
		<div class="sidebar-wrapper" ref="sidebarScrollArea">
			<slot></slot>
			<ul v-bind:class="navClasses">
				<slot name="links">
					<sidebar-item v-for="(link, index) in sidebarLinks" v-bind:key="link.name + index" v-bind:link="link">
						<sidebar-item v-for="(subLink, index) in link.children" v-bind:key="subLink.name + index" v-bind:link="subLink"></sidebar-item>
					</sidebar-item>
				</slot>
			</ul>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: 'СибирьТелематика'
			},
			type: {
				type: String,
				default: 'sidebar',
				validator: (value) => {
					let acceptedValues = ['sidebar', 'navbar']
					return acceptedValues.indexOf(value) !== -1
				}
			},
			backgroundColor: {
				type: String,
				default: 'black',
				validator: (value) => {
					let acceptedValues = ['white', 'brown', 'black']
					return acceptedValues.indexOf(value) !== -1
				}
			},
			activeColor: {
				type: String,
				default: 'success',
				validator: (value) => {
					let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
					return acceptedValues.indexOf(value) !== -1
				}
			},
			logo: {
				type: String,
				default: 'static/img/logo.png'
			},
			sidebarLinks: {
				type: Array,
				default: () => []
			}
		},
		computed: {
			sidebarClasses () {
				if (this.type === 'sidebar') {
					return 'sidebar'
				} else {
					return 'collapse navbar-collapse off-canvas-sidebar'
				}
			},
			navClasses () {
				if (this.type === 'sidebar') {
					return 'nav'
				} else {
					return 'nav navbar-nav'
				}
			}
		},
		methods: {
			async initScrollBarAsync () {
				await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
				const PerfectScroll = await import('perfect-scrollbar')
				PerfectScroll.initialize(this.$refs.sidebarScrollArea)
			}
		},
		mounted () {
			this.initScrollBarAsync()
		},
		beforeDestroy () {
			if (this.$sidebar.showSidebar) {
				this.$sidebar.showSidebar = false
			}
		}
	}

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue